/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFHoneypot } from './CRSFHoneypot';
import {
    CRSFHoneypotFromJSON,
    CRSFHoneypotFromJSONTyped,
    CRSFHoneypotToJSON,
} from './CRSFHoneypot';

/**
 * 
 * @export
 * @interface CRSFHoneypotsAggregate
 */
export interface CRSFHoneypotsAggregate {
    /**
     * 
     * @type {Array<CRSFHoneypot>}
     * @memberof CRSFHoneypotsAggregate
     */
    malicious: Array<CRSFHoneypot>;
    /**
     * 
     * @type {Array<CRSFHoneypot>}
     * @memberof CRSFHoneypotsAggregate
     */
    other: Array<CRSFHoneypot>;
    /**
     * 
     * @type {number}
     * @memberof CRSFHoneypotsAggregate
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFHoneypotsAggregate interface.
 */
export function instanceOfCRSFHoneypotsAggregate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "malicious" in value;
    isInstance = isInstance && "other" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFHoneypotsAggregateFromJSON(json: any): CRSFHoneypotsAggregate {
    return CRSFHoneypotsAggregateFromJSONTyped(json, false);
}

export function CRSFHoneypotsAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFHoneypotsAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'malicious': ((json['malicious'] as Array<any>).map(CRSFHoneypotFromJSON)),
        'other': ((json['other'] as Array<any>).map(CRSFHoneypotFromJSON)),
        'total': json['total'],
    };
}

export function CRSFHoneypotsAggregateToJSON(value?: CRSFHoneypotsAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'malicious': ((value.malicious as Array<any>).map(CRSFHoneypotToJSON)),
        'other': ((value.other as Array<any>).map(CRSFHoneypotToJSON)),
        'total': value.total,
    };
}

